export const AdminAuditSerializer = (data) => {
    if(data)
        return {
            id: data.log_id,
            tenant: data.tenant_id,
            admin: data.admin,
            message: data.message,
            insertDate: data.date_of_insert,
            insertUser: data.user_of_insert,
        }
    return null
  };


